if (module.hot) {
  module.hot.accept()
}

require('./App.tsx')